import React, { useState, useContext } from 'react';
import { styled } from '@mui/material/styles';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Button, TextField, Typography, useTheme } from '@mui/material';
import { AppContext } from '@/AppContext';
import ErrorBlock from '@/components/ErrorBlock/ErrorBlock';
import doc_links from 'common/doc_links';

const PREFIX = 'SignInReception';

const classes = {
  root: `${PREFIX}-root`,
  grid: `${PREFIX}-grid`,
  contentContainer: `${PREFIX}-contentContainer`,
  content: `${PREFIX}-content`,
  contentHeader: `${PREFIX}-contentHeader`,
  logoImage: `${PREFIX}-logoImage`,
  contentBody: `${PREFIX}-contentBody`,
  form: `${PREFIX}-form`,
  title: `${PREFIX}-title`,
  socialButtons: `${PREFIX}-socialButtons`,
  socialIcon: `${PREFIX}-socialIcon`,
  sugestion: `${PREFIX}-sugestion`,
  textField: `${PREFIX}-textField`,
  signInButton: `${PREFIX}-signInButton`,
  bottomText: `${PREFIX}-bottomText`,
  formContainer: `${PREFIX}-formContainer`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    // backgroundColor: theme.palette.background.default,
    height: '100%',
  },

  [`& .${classes.grid}`]: {
    height: '100%',
  },

  [`& .${classes.contentContainer}`]: {},

  [`& .${classes.content}`]: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },

  [`& .${classes.contentHeader}`]: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: theme.spacing(5),
    paddingBototm: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },

  [`& .${classes.logoImage}`]: {
    marginLeft: theme.spacing(4),
  },

  [`& .${classes.contentBody}`]: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  [`& .${classes.form}`]: {
    backgroundColor: '#fff',
    height: '352px',
    width: '600px',
    padding: 30,
    borderRadius: '8px',
    // flexBasis: 700,
    [theme.breakpoints.down('md')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },

  [`& .${classes.title}`]: {
    textAlign: 'center',
    // marginTop: theme.spacing(3),
    paddingBottom: '20px',
  },

  [`& .${classes.socialButtons}`]: {
    marginTop: theme.spacing(3),
  },

  [`& .${classes.socialIcon}`]: {
    marginRight: theme.spacing(1),
  },

  [`& .${classes.sugestion}`]: {
    marginTop: theme.spacing(2),
  },

  [`& .${classes.textField}`]: {
    marginTop: theme.spacing(2),
  },

  [`& .${classes.signInButton}`]: {
    margin: theme.spacing(2, 0),
  },

  [`& .${classes.bottomText}`]: {
    marginTop: '4px',
    width: '100%',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#213955',
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '16px',
  },

  [`& .${classes.formContainer}`]: {
    height: 'calc(100% - 111px)',
    padding: '20px  45px',
    border: '1px solid #ffffff',
    borderBottomColor: '#DEDEDE',
    borderTopColor: '#DEDEDE',
  },
}));

const SignInReception = () => {
  const theme = useTheme();

  const [formState, setFormState] = useState({
    isValid: true,
    values: {},
    touched: {},
    errors: {},
  });

  const handleChange = event => {
    event.persist();

    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]: event.target.type === 'checkbox' ? event.target.checked : event.target.value,
      },
      touched: {
        ...formState.touched,
        [event.target.name]: true,
      },
    }));
  };

  const appContext = useContext(AppContext);

  const handleSignIn = event => {
    event.preventDefault();
    appContext.receptionApi
      .receptionLogin({
        password: formState.values.pin,
      })
      .then(payload => {
        appContext.login(payload.data);
        appContext.history.push('/reception');
      })
      .catch(error => {
        const data = error.response.data;
        setFormState(formState => ({
          ...formState,
          errors: {
            meetupId: [data.message],
            pin: [data.message],
          },
        }));
      });
  };

  const hasError = field => (formState.touched[field] && formState.errors[field] ? true : false);

  return (
    <Root className={classes.root}>
      <div className={classes.content}>
        <div className={classes.contentBody}>
          <ErrorBlock message={formState.errors.token} />
          <form className={classes.form} onSubmit={handleSignIn}>
            <Typography className={classes.title} variant='h2'>
              Вход регистратора
            </Typography>
            <div className={classes.formContainer}>
              <TextField
                className={classes.textField}
                error={hasError('pin')}
                fullWidth
                helperText={hasError('pin') ? formState.errors.pin[0] : null}
                label='Пин-код регистратора'
                name='pin'
                onChange={handleChange}
                type='text'
                value={formState.values.pin || ''}
                variant='outlined'
              />
              <Button
                className={classes.signInButton}
                color='primary'
                fullWidth
                size='large'
                type='submit'
                variant='contained'
              >
                Войти
              </Button>
            </div>
            <div className={classes.bottomText} style={{ marginTop: '16px' }}>
              <p
                onClick={() =>
                  (window.location.href =
                    doc_links.receptionLogin)
                }
                style={{ cursor: 'pointer' }}
              >
                Где взять пин-код?
              </p>
            </div>
            <div className={classes.bottomText}>
              <p onClick={() => appContext.history.push('/sign-in')} style={{ cursor: 'pointer' }}>
                Вход администратора
              </p>
            </div>
          </form>
        </div>
      </div>
    </Root>
  );
};

SignInReception.propTypes = {
  history: PropTypes.object,
};

export default withRouter(SignInReception);
